<template>
  <b-row class="text-center">
     <div class="form-group col-lg-12 col-sm-12">
      <div class="input-group">
        <span class="input-group-btn">
          <!-- <b-button block variant="primary" @click.prevent="newDevice">New Dev</b-button> -->
          <router-link v-if="this.$can('config','create')" :to="{name: 'Add Config'}" class="btn btn-primary">Add+</router-link>
        </span>
        <input type="text" v-model="filterText" class="form-control" @keyup.enter="doFilter" placeholder="" autofocus>
        <span class="input-group-btn">
          <button type="button" class="btn btn-primary"  @click.prevent="doFilter">Search</button>
          <button type="button" class="btn btn-primary"  @click.prevent="resetFilter">Clear</button>          
        </span>          
      </div>
    </div>
    
  </b-row>
</template>

<script>
  export default {
    data () {
      return {
        filterText: '',        
      }
    },
    methods: {
      doFilter () {
        this.$events.fire('filter-set', this.filterText)
      },
      resetFilter () {
        this.filterText = ''
        this.$events.fire('filter-reset')
      },
      newDevice () {
        console.log('Message #: 12890')
      },      
    }    
  }
</script>
